import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CoachingSessionTypeDTO } from '../../dtos/coaching-session.dto';
import { ModalComponent, ModalConfig } from '../modals/modal/modal.component';

@Component({
  selector: 'app-hide-session-type-modal',
  templateUrl: './hide-session-type-modal.component.html',
  styleUrls: ['./hide-session-type-modal.component.scss'],
  standalone: false,
})
export class HideSessionTypeModalComponent {
  @ViewChild('internalModal')
  internalModal: ModalComponent;

  @Output() readonly confirmHide = new EventEmitter<CoachingSessionTypeDTO>();

  sessionType: CoachingSessionTypeDTO;

  modalConfig: ModalConfig = {
    titleText: 'Hide session type',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
  };

  open(sessionType: CoachingSessionTypeDTO) {
    this.sessionType = sessionType;
    this.internalModal.open();
  }

  closeModal() {
    this.internalModal.close();
  }

  continue() {
    this.internalModal.close();
    this.confirmHide.emit(this.sessionType);
  }
}
